import { useAuth } from '@/hooks';
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage';

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { myProfile } = useAuth();
  if (myProfile && !myProfile?.lastPasswordChangedAt) {
    return <ResetPasswordPage />;
  }

  return <>{children}</>;
};

export default AuthGuard;
